// ============================================================
// Search Module — Router (index.tsx)
// Lazy-loads the search sub-routes.
// Angular source: SearchModule (search/search.module.ts)
// ============================================================
import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const StudentSearch = lazy(() => import('./student/StudentSearch'));
const SchoolSearch = lazy(() => import('./school/SchoolSearch'));

const SearchModule: React.FC = () => {
  return (
    <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
      <Routes>
        <Route path="student" element={<StudentSearch />} />
        <Route path="school" element={<SchoolSearch />} />
      </Routes>
    </Suspense>
  );
};

export default SearchModule;
